import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import { toBlurOrNotToBlur } from './Carousel/Carousel.styles';

export const IframeContainer = styled(Box)`
  ${({ isBlurred }) => {
    return toBlurOrNotToBlur(isBlurred);
  }};
`;
